import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'

let resource = null

const actions = {
  getLatestLeaderboard: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/v2/latest-leaderboard/{presentationId}`,
  },

  // this action is still using /api/aha-sync/
  // but it's not being used anywhere
  getLeaderboard: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/leaderboards/{liveSessionId}/top?limit={limit}`,
  },

  createSlideLeaderboardInvidiual: {
    method: 'POST',
    url: `${configs.api.createLeaderboard}`,
  },
  addManualPoint: {
    method: 'POST',
    url: `${configs.baseUrl}/api/score/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateRandomEmoji = () => {
  return String.fromCodePoint(0x1F601 + Math.floor(Math.random() * 50))
}

const generateFakeAudiences = (count, topPoint) => {
  const audiences = []
  for (let i = count; i >= 0; i--) {
    audiences.push({
      audience: `bd2982e13e344088ad050167f49c${i}`,
      audienceName: `Audience ${i}`,
      audienceEmoji: generateRandomEmoji(),
      audienceTeam: 0,
      totalPoint: topPoint - (count - i) * topPoint * 0.02,
      index: count - i + 1,
    })
  }
  return audiences
}
export const fakeLeaderboardResp = {
  audiences: generateFakeAudiences(10, 1000),
  teams: null,
  cursor: '',
  hasNext: false,
  topAudienceStr: 'Ma',
}

/**
 * @deprecated
 * this function is using hard-coded /api/aha-sync/ endpoint
 * but it's not being used anymore. should delete
 */
const getLeaderboard = async ({ liveSessionId, limit }) => {
  return resource.getLeaderboard({ liveSessionId, limit })
}
const addManualPoint = async ({
  presentationId, audienceId, teamId, point, slideId,
}) => {
  const res = await resource.addManualPoint({
    presentationId, audienceId, teamId, point, slideId,
  })
  return res.body
}

const getLatestLeaderboard = async (payload, params = {}) => {
  const res = await resource.getLatestLeaderboard({
    presentationId: payload.presentationId,
    ...params,
  })
  if (res.body && res.body.audiences) {
    res.body.audiences = res.body.audiences.map((item) => {
      item.oP = item.oP || 0
      return {
        audienceName: item.aN,
        audienceEmoji: item.aE,
        audience: item.audience,
        audienceTeam: item.aT,
        totalPoint: item.tP,
        index: item.i,
        oldPoint: item.oP,
        newPoint: item.tP - item.oP,
        correctRate: item.cR,
        correctAnswersCount: item.cAc,
        streak: item.s,
        longestStreak: item.ls,
      }
    })
  }
  if (res.body && res.body.teams) {
    res.body.teams.forEach((team) => {
      team.oldPoint = team.oldPoint || 0
      team.newPoint = team.totalPoint - team.oldPoint
    })
  }
  if (res.body.countWinner === 1) {
    res.body.topAudienceStr = ''
  }
  return res
}

const createSlideLeaderboardToggle = async (payload) => {
  if (store.getters['leaderboard/canUseLeaderboardToggleOnPresenting']) {
    return getLatestLeaderboard({ presentationId: payload.presentationId }, { slideId: payload.slideId })
  }
  return resource.createSlideLeaderboardInvidiual(payload)
}

export default {
  initResource,
  getLeaderboard,
  getLatestLeaderboard,
  createSlideLeaderboardToggle,
  addManualPoint,
}
